import * as React from 'react';
import S from './DotPagination.styles';
const DotPagination = ({ ariaLabel, count, value, onChange }) => {
    return (React.createElement(S.Container, { as: !ariaLabel ? 'div' : 'nav', "aria-label": ariaLabel, "data-show-progress": count > 3 }, Array.from(Array(count)).map((_, index) => (React.createElement(S.Item, { key: `DotPaginationItem_${index}`, "aria-current": index === value, "aria-label": `Go to ${index + 1}`, "data-is-previous": index < value, onClick: (event) => {
            event.preventDefault();
            onChange(index);
        } })))));
};
export default DotPagination;
